import React, { useContext } from "react";
import { UI } from "@wwimmo/ui";
import { Trans } from "react-i18next";
import styles from "./AssemblyListRow.module.css";
import { RootStoreContext } from "src/stores/RootStore";
import { SCREEN_SIZE } from "src/stores/UIStore";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { Assembly } from "src/stores/assemblies/AssemblyStore";
import { getDate, getDateWithLongMonth } from "src/utils/Date";

const AssemblyListRowDesktopBase = (props: { assembly: Assembly; widths: number[] }) => {
    const { uiStore, authStore, assemblyStore } = useContext(RootStoreContext);
    const { id, date, assemblyrealestates, state, street, housenumber, zip, city, livemode } = props.assembly;

    const formatAddress = `${street && housenumber ? `${street} ${housenumber}` : ""}${
        street && housenumber && zip && city ? ", " : ""
    }${zip && city ? `${zip} ${city}` : ""}`;

    const { widths } = props;

    if (assemblyrealestates.length === 0) {
        return <div>/</div>;
    }

    const displayState = livemode ? "livemode_active" : state;

    // Extract the names of the first two real estates, if they exist
    const displayRealestateNames = assemblyrealestates
        .slice(0, 2) // Get only the first two items, if available
        .map((item) => item.realestate.name)
        .join(", ");

    return (
        <UI.List.Row className={styles.TicketListRow} key={id}>
            <UI.List.Cell
                value={uiStore.currentScreenSize > SCREEN_SIZE.LAPTOP ? getDateWithLongMonth(date) : getDate(date)}
                colspan={widths[0]}
            />
            {authStore.user?.hasOnlyCoownerRole ||
            authStore.user?.hasOnlyCoownerAuditorRole ||
            authStore.user?.hasCoownerOwnerRole ||
            assemblyStore.isManagerRealestateAssemblyRoute ? undefined : (
                <>
                    <UI.List.Cell
                        value={
                            assemblyrealestates && assemblyrealestates.length > 0
                                ? assemblyrealestates[0].realestate.number
                                : "/"
                        }
                        colspan={widths[1]}
                    />
                    <UI.List.Cell
                        colspan={widths[2]}
                        value={
                            <div className={styles.RealestateNames}>
                                {displayRealestateNames}
                                {assemblyrealestates.length > 2 && (
                                    <>
                                        , <span className={styles.Dots}>...</span>
                                    </>
                                )}
                            </div>
                        }
                        truncate
                    />
                </>
            )}
            <UI.List.Cell value={formatAddress} colspan={widths[3]} />
            <UI.List.Cell
                className={`${uiStore.currentScreenSize <= SCREEN_SIZE.LAPTOP ? "d-none" : "d-flex"}`}
                colspan={widths[4]}
                value={
                    <div className={styles[`status-${displayState}`]}>
                        <Trans>screens.assemblies.states.{displayState}</Trans>
                    </div>
                }
                truncate
            />
        </UI.List.Row>
    );
};

export const AssemblyListRowDesktop = Sentry.withProfiler(observer(AssemblyListRowDesktopBase));
